import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class BiaImpactConfigurationApi extends BaseApi {
    constructor(client) {
        super(client, '/bia-impact-configuration');
    }

    async getBiaImpactConfiguration() {
        try {
            const response = await this.client.get(this.basePath);
            return response.data || response;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async updateBiaImpactConfiguration(data) {
        try {
            const response = await this.client.put(this.basePath, data);
            return response.data || response;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
